export const ID_ERROR = 'error';
export const PRODUCTION = 'production';
